import { lazy } from "react";
import { Navigate, Outlet, type RouteObject } from "react-router";
import MainLayout from "@/layouts/MainLayout";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

const PublicOnlyRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : <Outlet />;
};

export const routes: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: "/",
            Component: lazy(() => import("@/views/pages/home")),
          },
          {
            path: "/profile",
            Component: lazy(() => import("@/views/pages/profile")),
          },
          {
            path: "/engagement-requests",
            Component: lazy(() => import("@/views/pages/pharma/engagement-requests")),
          },
          {
            path: "/find-doctors",
            Component: lazy(() => import("@/views/pages/pharma/find-doctors")),
          },
          {
            path: "/events-broadcasts",
            Component: lazy(() => import("@/views/pages/pharma/events-broadcasts")),
          },
          {
            path: "/payments-compliance",
            Component: lazy(() => import("@/views/pages/pharma/payments-compliance")),
          },
          {
            path: "/team-settings",
            Component: lazy(() => import("@/views/pages/pharma/team-settings")),
          },
        ],
      },
    ],
  },

  {
    path: "/auth/delete-account",
    Component: lazy(() => import("@/views/auth/delete-account")),
  },
  {
    path: "/auth/login-pin",
    Component: lazy(() => import("@/views/auth/login-pin")),
  },
  {
    path: "/auth/verify-pass",
    Component: lazy(() => import("@/views/auth/verify-pass-otp")),
  },
  {
    path: "/auth/req-pass",
    Component: lazy(() => import("@/views/auth/req-pass-otp")),
  },
  {
    path: "/attendance/:attendance_token",
    Component: lazy(() => import("@/views/pages/old/attendanceForm")),
  },
  {
    element: <PublicOnlyRoute />,
    children: [
      {
        path: "/login",
        Component: lazy(() => import("@/views/auth/sign-in")),
      },
      {
        path: "/sign-up",
        Component: lazy(() => import("@/views/auth/sign-up")),
      },
    ],
  },
  { path: "/error/400", Component: lazy(() => import("@/views/error/400")) },
  { path: "/error/401", Component: lazy(() => import("@/views/error/401")) },
  { path: "/error/403", Component: lazy(() => import("@/views/error/403")) },
  { path: "/error/404", Component: lazy(() => import("@/views/error/404")) },
  { path: "/error/408", Component: lazy(() => import("@/views/error/408")) },
  { path: "/error/500", Component: lazy(() => import("@/views/error/500")) },
  {
    path: "/error/maintenance",
    Component: lazy(() => import("@/views/error/maintenance")),
  },
];
